/** @format */
import { useTranslation } from 'next-i18next';
import { useContext } from 'react';

import { SearchFacet } from '@toucan/common/services/search/constants';

import { MarketContext } from '@toucan/client/global/market';

import { useSearchParams } from '@toucan/client/features/search/components/model-search-results/hooks/use-search-params';
import {
    Filter,
    PreTranslatedFilter,
} from '@toucan/client/features/search/components/model-search-results/types';

import {
    getDefaultFilterOptions,
    getNumberFilterOptions,
    getProductConditionFilterOptions,
    getProductPriceFilterOptions,
    getYearOfReleaseFilterOptions,
} from './helpers';

export function useTranslateFilters(filters: PreTranslatedFilter[]): Filter[] {
    const { t } = useTranslation();
    const { activeMarket } = useContext(MarketContext);
    const searchParams = useSearchParams();

    return filters.map((filter) => {
        if (filter.id === SearchFacet.modelYearOfReleaseModelSpecificationNum) {
            return {
                ...filter,
                values: getYearOfReleaseFilterOptions(filter, t),
            };
        }

        if (filter.id.endsWith('Num')) {
            return {
                ...filter,
                values: getNumberFilterOptions(filter, activeMarket, t),
            };
        }

        if (filter.id === SearchFacet.productPrice) {
            return {
                ...filter,
                ...getProductPriceFilterOptions(
                    filter,
                    activeMarket,
                    t,
                    searchParams
                ),
            };
        }

        if (filter.id === SearchFacet.productConditionStarRating) {
            return {
                ...filter,
                values: getProductConditionFilterOptions(filter, t),
            };
        }

        return {
            ...filter,
            values: getDefaultFilterOptions(filter, t),
        };
    });
}
